export default {"src":"/_next/static/media/white-furniture.b420ddc3.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};